<template>
    <div class="page-table tabStyle mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.tanimlama.baslikH1")}}</div>
        <el-form status-icon :model="urunForm" :rules="rulesUrun" ref="urunForm" class="demo-ruleForm">
            <el-row :gutter="10">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             href="https://www.kaderfood.ch/">
                                                        https://www.kaderfood.ch/{{this.urunForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">https://www.kaderfood.ch/ </span>
                                                <el-input size="small" v-if="VisibleA" v-model="urunForm.link"
                                                          v-on:change="linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%"></el-input>
                                            </div>
                                            <el-input size="small"
                                                      v-model="urunForm.baslik"
                                                      v-on:change="linkTespit"
                                                      :placeholder='$t("src.views.apps.urun.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input size="small" v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Fiyat'
                                                prop="fiyat">
                                            <el-input size="small" v-model="urunForm.fiyat">
                                                <template slot="append">CHF</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Eski Fiyat'
                                                prop="eskiFiyat">
                                            <el-input size="small" v-model="urunForm.eskiFiyat">
                                                <template slot="append">CHF</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.icerik"
                                                      @input="seoIcerikTespit"
                                                      @blur="seoIcerikTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim") + " (800x600)"'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunForm.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="seoIcerik">:
                                                <el-input size="small" type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-de"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik") + "(Almanca)"'
                                                      prop="dil.de.baslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.dil.de.baslik"
                                                      v-on:change="urunForm.dil.de.seoBaslik = urunForm.dil.de.baslik.substring(0, 60)"
                                                      :placeholder='$t("src.views.apps.urun.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik") + "(Almanca)"'
                                                      prop="dil.de.altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.dil.de.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input size="small" v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Fiyat'
                                                prop="fiyat">
                                            <el-input size="small" v-model="urunForm.fiyat">
                                                <template slot="append">₺</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik") + "(Almanca)"'
                                                      prop="dil.de.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      @input="seoIcerikDETespit"
                                                      @blur="seoIcerikDETespit"
                                                      v-model="urunForm.dil.de.icerik"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim") + " (800x600)"'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik") + "(Almanca)"'
                                                    prop="dil.de.seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunForm.dil.de.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik") + "(Almanca)"'
                                                    prop="dil.de.seoIcerik">:
                                                <el-input size="small" type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikDEChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.dil.de.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik") + "(İngilizce)"'
                                                      prop="dil.en.baslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.dil.en.baslik"
                                                      v-on:change="urunForm.dil.en.seoBaslik = urunForm.dil.en.baslik.substring(0, 60)"
                                                      :placeholder='$t("src.views.apps.urun.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik") + "(İngilizce)"'
                                                      prop="dil.en.altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.dil.en.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input size="small" v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Fiyat'
                                                prop="fiyat">
                                            <el-input size="small" v-model="urunForm.fiyat">
                                                <template slot="append">₺</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik") + "(İngilizce)"'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      @input="seoIcerikENTespit"
                                                      @blur="seoIcerikENTespit"
                                                      v-model="urunForm.dil.en.icerik"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim") + " (800x600)"'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik") + "(İngilizce)"'
                                                    prop="dil.en.seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunForm.dil.en.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik") + "(İngilizce)"'
                                                    prop="dil.en.seoIcerik">:
                                                <el-input size="small" type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikENChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.dil.en.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1"
                                          :title='$t("src.views.apps.urun.kategori.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select
                                                v-model="urunForm.durum"
                                                style="width: 100%">
                                            <el-option value="0" label="Taslak">Taslak</el-option>
                                            <el-option value="1" label="Yayınla">Yayınla</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini"
                                        v-on:click="urunTanimlama('urunForm',urunForm.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="urunForm.durum === '1'">{{$t('src.views.apps.urun.kategori.tanimlama.urunKategoriEkle')}}</label>
                                    <label v-else>Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.urun.kategori.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('urunForm')">
                                            {{$t('src.views.apps.urun.kategori.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.urun.kategori.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.urun.kategori.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip :content="$t('src.views.apps.urun.kategori.tanimlama.copKutusu')"
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button class="cop" v-on:click="urunTanimlama('urunForm','0')"
                                               type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item class="card-shadow--medium"
                                          title='* Kategori' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="kategoriList">
                                        <el-tree
                                                class="baskaTree"
                                                ref="kategori"
                                                :data="kategoriListesi"
                                                @check='handleNodeClick'
                                                node-key="id"
                                                icon-class
                                                show-checkbox
                                                :props="defaultProps">
                                        </el-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item v-if="malzemeVis" class="card-shadow--medium"
                                          title='* Malzemeler' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="malzemeList">
                                        <el-tree
                                                class="baskaTree"
                                                :data="malzemeList"
                                                @check="handleNodeClickMal"
                                                node-key="id"
                                                icon-class
                                                show-checkbox
                                                :props="defaultPropsMal">
                                        </el-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item v-if="malzemeVis" class="card-shadow--medium"
                                          title='* Çıkarılacak Malzemeler' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="cikarilacakMalzemeList">
                                        <el-tree
                                                class="baskaTree"
                                                :data="cikarilacakMalzemeList"
                                                @check="handleNodeClickCikarilacakMal"
                                                node-key="id"
                                                icon-class
                                                show-checkbox
                                                :props="defaultPropsMal">
                                        </el-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <!--<el-collapse-item class="card-shadow&#45;&#45;medium"-->
                        <!--title='Opsiyon' name="2">-->
                        <!--<el-row>-->
                        <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">-->
                        <!--<el-form-item prop="opsiyonList">-->
                        <!--<el-tree-->
                        <!--class="baskaTree"-->
                        <!--:data="opsiyonListesi"-->
                        <!--@check="handleNodeClickOps"-->
                        <!--node-key="id"-->
                        <!--icon-class-->
                        <!--show-checkbox-->
                        <!--:props="defaultProps1">-->
                        <!--</el-tree>-->
                        <!--</el-form-item>-->
                        <!--</el-col>-->
                        <!--</el-row>-->
                        <!--</el-collapse-item>-->
                    </el-collapse>
                    <!--<div :lg="6" :md="6" :sm="24" :xs="24"-->
                    <!--v-for="(item,index) in secilenOpsiyonlar"-->
                    <!--:key="index">-->
                    <!--<el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">-->
                    <!--<el-collapse v-model="collapseOps">-->
                    <!--<el-collapse-item :title='item.label' :name="index"-->
                    <!--class="margin-top-10 card-shadow&#45;&#45;medium">-->
                    <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"-->
                    <!--style="margin-top: 5px">-->
                    <!--<el-form-item :label='item.label'>:-->
                    <!--<el-input size="small"  v-model="opsiyonAciklamaForm.opsiyonBaslik[index]"></el-input>-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"-->
                    <!--style="margin-top: 5px">-->
                    <!--<el-form-item :label='item.label + "(Almanca)"'>:-->
                    <!--<el-input size="small"  v-model="opsiyonAciklamaForm.opsiyonBaslikEN[index]"></el-input>-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <!--</el-collapse-item>-->
                    <!--</el-collapse>-->
                    <!--</el-collapse>-->
                    <!--</div>-->
                </el-col>
            </el-row>
        </el-form>
        <el-dialog
                title='Sunucudan Fotoğraf Seç'
                :visible.sync="dialogImgServerVisible"
                width="60%"
                center>
            <el-upload
                    action="#"
                    accept=".jpg,.jpeg,.png"
                    :on-change="serverImageUpload"
                    list-type="picture-card"
                    :file-list="imageListServer"
                    :auto-upload="false">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                </div>
            </el-upload>
        </el-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
    import EventBus from '@/components/event-bus'

    const VueScrollTo = require('vue-scrollto')
    Vue.use(VueScrollTo)
    import urunService from '../../../WSProvider/UrunService'
    import seoService from '../../../WSProvider/SeoService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'
    import functions from '../../../functions'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataKader = "";
    export default {
        name: "UrunTanimla",
        components: {},
        mounted() {
            this.getKategoriList();
            // this.getOpsiyonList();
            let self = this;
            EventBus.$on('malzemeList', function(bool){
                if(bool){
                    self.getukategoriMalzemeList();
                }
            });
            EventBus.$on('ukategoriList', function(bool){
                if(bool){
                    self.getKategoriList();
                }
            });
        },
        data() {
            return {
                dialogKonum: false,
                malzemeVis: false,
                kategoriVis: true,
                konumText: "Seç",
                limit: 0,
                defaultProps: {
                    id: 'id',
                    children: 'children',
                    label: 'name'
                },
                defaultPropsMal: {
                    id: 'umalzemeId',
                    label: 'baslik'
                },
                defaultProps1: {
                    label: 'baslik'
                },
                imageListServer: [],
                ozelAlanListesi: [],

                secilenOpsiyonlar: [],
                dialogImgServerVisible: false,
                seoIcerikChange: true,
                seoIcerikDEChange: true,
                seoIcerikENChange: true,
                VisibleA: false,
                linkChange: true,
                linkVisible: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                kategoriListesi: [],
                malzemeList: [],
                cikarilacakMalzemeList: [],
                opsiyonListesi: [],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3', '4', '5'],
                collapseOps: ['1'],
                opsiyonAciklamaForm: {
                    opsiyonBaslik: [],
                    opsiyonBaslikDE: [],
                },
                visibleSil: false,
                visibleBoya: false,
                checked: true,
                urunForm: {
                    baslik: "",
                    altBaslik: "",
                    icerik: "",
                    link: '',
                    urunKodu: '',
                    seoBaslik: '',
                    seoIcerik: '',
                    fiyat: '',
                    eskiFiyat: '',
                    resim: [],
                    kategoriList: [],
                    opsiyonList: [],
                    malzemeList: [],
                    cikarilacakMalzemeList: [],
                    durum: "1",
                    dil: {
                        de: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        },
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        },

                    },
                },
                rulesUrun: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    fiyat: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    urunKodu: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    kategoriList: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    // malzemeList: [{
                    //     required: true,
                    //     message: " ",
                    //     trigger: 'blur'
                    // }],
                },
            }
        },
        methods: {
            urunTanimlama(formName, durum) {
                let self = this;
                var dizi = [];
                var dil = [];
                this.urunForm.resim = [];
                this.$refs.urunForm.validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.urunForm.resim.push(e.name);
                        });
                        // for (var i = 0; i < this.secilenOpsiyonlar.length; i++) {
                        //     var item = ({
                        //         uopsiyonId: this.secilenOpsiyonlar[i].opsiyonId,
                        //         aciklama: this.opsiyonAciklamaForm.opsiyonBaslik[i],
                        //         dil: {
                        //             en: this.opsiyonAciklamaForm.opsiyonBaslikEN[i],
                        //         }
                        //     });
                        //     dizi.push(item)
                        // }
                        dil = {
                            de: {
                                baslik: this.urunForm.dil.de.baslik,
                                altBaslik: this.urunForm.dil.de.altBaslik,
                                icerik: this.urunForm.dil.de.icerik,
                                seoBaslik: this.urunForm.dil.de.seoBaslik,
                                seoIcerik: this.urunForm.dil.de.seoIcerik

                            },
                            en: {
                                baslik: this.urunForm.dil.en.baslik,
                                altBaslik: this.urunForm.dil.en.altBaslik,
                                icerik: this.urunForm.dil.en.icerik,
                                seoBaslik: this.urunForm.dil.en.seoBaslik,
                                seoIcerik: this.urunForm.dil.en.seoIcerik

                            },
                        };
                        
                        urunService.urunTanimlama(this.urunForm.urunKodu, this.urunForm.link, this.urunForm.baslik,
                            this.urunForm.altBaslik, this.urunForm.icerik, this.urunForm.fiyat, this.urunForm.eskiFiyat, this.urunForm.seoBaslik,
                            this.urunForm.seoIcerik, this.urunForm.resim, durum, dil, this.urunForm.kategoriList, [], this.urunForm.malzemeList, this.urunForm.cikarilacakMalzemeList
                        ).then((response) => {
                            if (response.status === 200) {
                                this.getKategoriList();
                                this.$refs[formName].resetFields();
                                EventBus.$emit("urunList", true);
                                this.urunForm.link = '';
                                this.linkVisible = false;
                                this.urunForm.kategoriList = [];
                                this.imageListMain = [];
                                this.urunForm.opsiyonList = [];
                                this.secilenOpsiyonlar = [];
                                this.formKapat()
                                notification.Status('success', this, 'Ürün Başarıyla Kaydedildi.');
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ürün zaten mevcut!');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    } else {
                        notification.Status('warning', this, 'Doldurulması zorunlu olan alanları gözden geçiriniz ve kategori seçiniz!!');
                    }
                });
            },
            formKapat() {
                let tabs = this.$store.getters.getTabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "urunTanimla");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "urunTanimla") {
                            this.$store.getters.getTabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            handleNodeClick(data, checked, indeterminate) {
                if(checked.checkedNodes.length > 0){
                    let self = this;
                    this.urunForm.kategoriList = [];
                    if (!data.children || !data.children.length) {
                        if (checked.checkedNodes.length > 0) {
                            this.$refs.kategori.setCheckedKeys([data.id])
                            this.urunForm.kategoriList.push(data.id)
                        }
                    } else {
                        this.$refs.kategori.setCheckedKeys([])
                    }

                    this.getukategoriMalzemeList();
                }
                else{
                    this.malzemeVis = false;
                    this.malzemeList = []
                    this.cikarilacakMalzemeList = [];
                }
            },


            handleNodeClickMal(data, checked, indeterminate) {
                this.urunForm.malzemeList = checked.checkedNodes;
            },
            handleNodeClickCikarilacakMal(data, checked, indeterminate) {
                this.urunForm.cikarilacakMalzemeList = checked.checkedNodes;
                console.log("handle node click : ", checked.checkedNodes)
            },
            getukategoriMalzemeList() {
                urunService.ukategoriMalzemeList(this.urunForm.kategoriList[0]).then((response) => {
                    if (response.status === 200) {
                        this.malzemeList = response.data;
                        this.cikarilacakMalzemeList = response.data;
                        /*var obj = this.urunForm.kategoriList.find(o => o === "3") // içecek id = 3
                        if(obj){
                            var icecek = this.malzemeList.find(o => o.baslik === "içecekler") // malzeme listte tekrar içecek olmamalı
                            if(icecek){
                                this.malzemeList = this.malzemeList.filter(function(obj){
                                    return obj.baslik !== "içecekler"
                                })
                            }
                        }*/
                        this.malzemeVis = true;
                        
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },

            // handleNodeClickOps(data, checked, indeterminate) {
            //
            //     let self = this;
            //     if (checked.checkedKeys.length > 0) {
            //         let obj = checked.checkedNodes.find(dizi => dizi.uopsiyonId === data.uopsiyonId);
            //         if (obj !== undefined) {
            //             this.secilenOpsiyonlar.push({
            //                 opsiyonId: data.uopsiyonId,
            //                 label: data.baslik,
            //             });
            //         } else {
            //             this.secilenOpsiyonlar.forEach(function (e, i) {
            //                 if (e.opsiyonId === data.uopsiyonId) {
            //                     self.secilenOpsiyonlar.splice(i, 1);
            //                 }
            //             });
            //         }
            //     }
            //     else self.secilenOpsiyonlar = []
            // },
            linkTespitLink() {
                let self = this;
                if (this.urunForm.link) {
                    seoService.linkKontrol(self.urunForm.link.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            self.urunForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    seoService.linkKontrol(self.urunForm.baslik.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            if (self.urunForm.baslik) {
                                self.urunForm.seoBaslik = self.urunForm.baslik.substring(0, 60);
                                if (response.status === 200) {
                                    self.linkVisible = true;
                                    self.urunForm.link = response.data;
                                }
                            } else if (!self.urunForm.baslik) {
                                self.linkVisible = false;
                                self.urunForm.link = '';
                                self.urunForm.seoBaslik = '';
                            }
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            seoIcerikTespit() {
                if (this.seoIcerikChange) {
                    const myStr = functions.strip_html_tags(this.urunForm.icerik);
                    this.urunForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDETespit() {
                if (this.seoIcerikDEChange && this.urunForm.dil.de.icerik) {
                    const myStr = functions.strip_html_tags(this.urunForm.dil.de.icerik);
                    this.urunForm.dil.de.seoIcerik = myStr.substring(0, 140);
                } else this.urunForm.dil.de.seoIcerik = '';
            },
            seoIcerikENTespit() {
                if (this.seoIcerikENChange && this.urunForm.dil.en.icerik) {
                    const myStr = functions.strip_html_tags(this.urunForm.dil.en.icerik);
                    this.urunForm.dil.en.seoIcerik = myStr.substring(0, 140);
                } else this.urunForm.dil.en.seoIcerik = '';
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, "urun-" + functions.randomText(7) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim('urun').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: urunService.imageUrlOrta + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            imageUploadtoServer(file) {
                let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                if (obj === undefined) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    notification.Status('warning', this, 'Bu resim zaten mevcut');
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonk(file, imgname, item) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('urun', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.imageListMain.push(item);
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.urunForm.baslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "urun-" + functions.randomText(7) + '-' + this.urunForm.link + ".jpg";
                        } else {
                            imgname = "urun-" + functions.randomText(7) + '-' + this.urunForm.link + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "urun-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "urun-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                    if (obj === undefined) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.sumResimFonk(file, imgname, item);
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
            },
            getKategoriList() {
                urunService.kategoriTree().then((response) => {
                    if (response.status === 200) {
                        this.kategoriListesi = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            getOpsiyonList() {
                urunService.uopsiyonList(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.opsiyonListesi = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
        }
    }


</script>
<style scoped>
    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }

</style>
<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';


    #transfer1 {
        display: flex;
    }

    #transfer2 {
        display: flex;
        position: relative;
        left: 25px;
    }

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>
